import React from "react";
import "./Home.css";
import Hero from "../Hero/Hero";
import StatsSection from "../Stats/StatsSection";
import Services from "../Services/Services";
import CaseStudies from "../CaseStudies/CaseStudies";
import Strategies from "../Strategies/Strategies";
import Process from "../Process/Process";
import Testimonials from "../Testimonials/Testimonials";
import Banner from "../Banner/Banner";

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <StatsSection />
      <Services />
      <CaseStudies />
      <Strategies />
      <Process />
      <Testimonials />
      <Banner />
    </div>
  );
};

export default Home;
